import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { Org } from "../models/OrgModel";
import { Oauth2Config } from "../models/Oauth2Model";


export default class OAuthApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getOauth2Config(pk_cuaa: number, providerCode: string) {
        const url = `/iot/api/v1/farm/${pk_cuaa}/provider/${providerCode}/oauth2/config`;
        return (await this.http.get<Oauth2Config>(url)).data;
    }

    public async login(pk_cuaa: number, oauth2Config: Oauth2Config): Promise<string> {
        const http = new HTTPClient();

        let auth_ep = oauth2Config.baseURL + oauth2Config.authEndpoint;
        if(oauth2Config.baseURL.endsWith('/.well-known/oauth-authorization-server')){
            const { data } = await http.get(oauth2Config.baseURL);
            auth_ep =  data.authorization_endpoint;
        }
        const url = auth_ep + '?' +
        [
            oauth2Config.scope ? `scope=${oauth2Config.scope}` : null,
            'response_type=code',
            `redirect_uri=${oauth2Config.redirectURL}`,
            `client_id=${oauth2Config.clientId}`,
            `state=${pk_cuaa}`,
            ... Object.entries(oauth2Config.additionalAuthParams).map(keyVal => {
                const key = keyVal[0];
                const value = keyVal[1];
                return `${key}=${value}`
            })
        ].filter(value => value != null).join('&')

        return url
    }

    public async loginWithCode(code: string, pk_cuaa: string, providerCode: string): Promise<boolean>
    {
        const res = await this.http.post(`/iot/api/v1/farm/${pk_cuaa}/provider/${providerCode}/code/${code}`)

        return res.status === 204
    }

    public async getOrgs(pk_cuaa: number): Promise<Org[]>
    {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/mjd/subjects/${pk_cuaa}/linked_orgs`);
        return res.data || [];
    } 
}
